import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';
import UserUtils from 'user/user-utils';

export default class UserDetail extends Component {
    static propTypes = {
        user: PropTypes.object,
        onUserChange: PropTypes.func.isRequired,
    };
    state = {
        logoutLoading: false,
    };

    _onClick = () => {
        const {user, onUserChange} = this.props;

        this.setState({
            logoutLoading: true,
        });

        if (user.status !== UserUtils.AUTH_STATE.LOGGED_OUT) {
            onUserChange({
                user: null,
            });
        } else {
            onUserChange({user});
        }
    };

    render() {
        const {
            user: {status},
        } = this.props;
        const {logoutLoading} = this.state;

        return (
            <div className="UserDetail CheckoutPanel-title-actions">
                <TextButton
                    disabled={logoutLoading}
                    loading={logoutLoading}
                    onClick={this._onClick}
                >
                    {status === UserUtils.AUTH_STATE.USER
                        ? 'Sign out'
                        : 'Sign in'}
                </TextButton>
            </div>
        );
    }
}
